import { useSelector } from 'react-redux'

const useUserDateFormat = () => {
  const userFormat = useSelector(({ user }) => user.settings?.date_format)

  return userFormat ?? null
}

export default useUserDateFormat
